import React from "react";
import { Dialog, DialogContent, Box, Typography, Button, useMediaQuery } from "@mui/material";
import theme from "../../util/theme/theme";
import DateInput from "../ui/date-input";

export interface DateConfirmPopupProps {
    open: boolean;
    message?: string;
    red?: boolean;
    description?: string;
    footer?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    dateLabel?: string;
    value: string;
    minDate?: string;
    onChange: (value: string) => void;
    onConfirm: () => void;
    onCancel: () => void;
    confirmDisabled?: boolean;
}

const DateConfirmPopup: React.FC<DateConfirmPopupProps> = ({
    open,
    message = "Are you sure?",
    red = false,
    footer,
    description = "This action cannot be undone.",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    dateLabel = "End Date",
    value,
    minDate,
    onChange,
    onConfirm,
    onCancel,
    confirmDisabled = false,
}) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    let contentStyle = { p: 0, pt: 3, pb: 3, px: 4, textAlign: 'center', minWidth: 340 };
    if (isMobile) contentStyle = { p: 2, pt: 3, pb: 3, px: 2, textAlign: 'center', minWidth: 200 };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" PaperProps={{ sx: { borderRadius: isMobile ? 2 : 4, p: 0, overflow: 'hidden' } }}>
            <DialogContent sx={contentStyle}>
                <Typography variant="h6" fontWeight={700} mb={1.5} color={red ? "#F44336" : "inherit"}>
                    {message}
                </Typography>
                <Typography
                    color="text.secondary"
                    fontSize={16}
                    mb={3}
                    component="div"
                    dangerouslySetInnerHTML={description ? { __html: description } : undefined}
                />
                <Box mb={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <DateInput label={dateLabel} value={value} onChange={onChange} minDate={minDate} />
                </Box>
                {footer && (
                    <Typography fontWeight={600} mb={1.5} color="text.secondary">
                        {footer}
                    </Typography>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={confirmDisabled}
                    sx={{ borderRadius: 2, fontWeight: 600, fontSize: 17, py: 1.2, mb: 1.5, boxShadow: 'none', textTransform: 'none', color: '#fff' }}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    sx={{ borderRadius: 2, fontWeight: 600, fontSize: 17, py: 1.2, textTransform: 'none' }}
                    onClick={onCancel}
                >
                    {cancelLabel}
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default DateConfirmPopup;
